import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { Navigation, Pagination, Autoplay, EffectCards } from 'swiper/modules';

const fadeIn = () => {
    const lists = document.querySelectorAll(
        ".jobs-carousel .attrax-list-widget__list, .post-carousel .attrax-list-widget__list"
    );
    lists.forEach((list) => list.classList.add("show"));
};

export const createNavigationButtonContainer = (swiperInstance: Swiper) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("swiper-nav-btn-container");
    const navButtons = swiperInstance.el.querySelectorAll(
        ".swiper-button-prev, .swiper-button-next"
    );

    for (let btn of navButtons) {
        btn.remove();
        wrapper.appendChild(btn);
    }

    swiperInstance.el.appendChild(wrapper);
};

export const createViewAllButtonContainer = (swiperInstance: Swiper) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("swiper-view-all");
    const viewAllButton = swiperInstance.el.querySelectorAll(
        ".swiper-slide.attrax-button"
    );

    for (let btn of viewAllButton) {
        btn.remove();
        btn.classList.remove("swiper-slide");
        btn.setAttribute("style", "");
        btn.setAttribute("aria-label", "view all");
        wrapper.appendChild(btn);
    }

    swiperInstance.el.appendChild(wrapper);
};

const createCarousel = (el: string, opt: SwiperOptions) => {
    const elements = document.querySelectorAll(el);

    elements.forEach((element: HTMLElement) => {
        const children = [...element.children];

        element.classList.add("swiper");
        for (let child of children) {
            child.classList.add("swiper-slide");
        }

        const pagination = document.createElement("div");
        pagination.classList.add("swiper-pagination");
        element.appendChild(pagination);

        const swiper = new Swiper(element, {
            modules: [ Navigation, Pagination ],
            createElements: true,
            navigation: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            on: {
                afterInit: (swiper) => {
                    createNavigationButtonContainer(swiper);
                },
            },
            ...opt,
        });
    });
};

const createVideoCarousel = () => {
    const numberofSlides = (carousel)  => {
        const slides = carousel.querySelectorAll(".swiper-slide");

        const numberOfSlides = slides.length;

        if (numberOfSlides < 4) {
            carousel.classList.add("banner-carousel-video--small");
        }
    }


    createCarousel(".banner-carousel-video", {
        modules: [ Autoplay, Pagination, Navigation ],
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 24,
        centerInsufficientSlides: true,
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            990: {
                slidesPerView: 3,
            },
        },
        on: {
            afterInit: (swiper) => {
                numberofSlides(swiper.el);
                createNavigationButtonContainer(swiper);
            }
        }
    });
};

const createTestimonialsCarousel = () => {
    createCarousel(".carousel-testimonials", {
        modules: [ Autoplay, Navigation, Pagination ],
        grabCursor: true,
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        spaceBetween: 68,
    });
};

const createPostCarousel = () => {
    createCarousel(".posts-carousel .attrax-list-widget__list--has-items", {
        modules: [ EffectCards, Pagination, Navigation ],
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 24,
        on: {
            afterInit: (swiper) => {
                createViewAllButtonContainer(swiper);
                createNavigationButtonContainer(swiper);
                fadeIn()
            }
        },
    });
};

const createJobCarousel = () => {
    createCarousel(".jobs-carousel .attrax-list-widget__list--has-items", {
        modules: [ EffectCards, Pagination, Navigation ],
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 24,
        on: {
            afterInit: (swiper) => {
                createViewAllButtonContainer(swiper);
                createNavigationButtonContainer(swiper);
                fadeIn()
            }
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            990: {
                slidesPerView: 3,
            },
        },
    });
};

const createAwardsCarousel = () => {
    createCarousel('.carousel-awards', {
        modules: [ Pagination, Navigation ],
        loop: true,
        grabCursor: true,
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
            370: {
                slidesPerView: 2,
            },
            640: {
                slidesPerView: 3,
            },
            990: {
                slidesPerView: 4,
                spaceBetween: 24,
            },
        },
    })
}

export const CreateCarousels = () => {
    createVideoCarousel();
    createJobCarousel();
    createPostCarousel();
    createTestimonialsCarousel();
    createAwardsCarousel();
};
